import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';
import AdminAddDashboards from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboards/AdminAddDashboards';
import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { type FC } from 'react';
import { useParams } from 'react-router-dom';

const AdminAddDashboardsSubsubarea: FC = () => {
  const { dashboards } = useDashboardContext();
  const { areas } = useAreaContext();
  const { areaId, subareaId, subsubareaId } = useParams();

  const area = areas?.find((areaItem) => areaItem.id === areaId);
  const subarea = area?.subareas.find((subareaItem) => subareaItem.id === subareaId);
  const subsubarea = subarea?.subsubareas.find(
    (subsubareaItem) => subsubareaItem.id === subsubareaId,
  );

  if (!dashboards) return <></>;

  return (
    <>
      <Typography variant="h3" sx={{ paddingRight: '40px' }}>
        {area?.name} - {subarea?.name} - {subsubarea?.name}
      </Typography>
      <Box>
        <AdminAddDashboards
          items={dashboards.filter(
            (dashboard: Dashboard) => dashboard.area.subsubareaId === subsubareaId,
          )}
          actions={{
            add: true,
            edit: true,
            delete: true,
          }}
        />
      </Box>
    </>
  );
};

export default AdminAddDashboardsSubsubarea;
